export default {
  namespaced: true,
  state: {
    isFetching: false,
    isErrored: false,
    error: {},
  },
  mutations: {
    setFetching(state, isFetching) {
      state.isFetching = isFetching;
    },
    setError(state, error) {
      state.isFetching = false;
      state.isErrored = true;
      state.error = error;
    }
  },
}